import { render, staticRenderFns } from "./ThirdCompanyDetails.vue?vue&type=template&id=58fb06cb&scoped=true"
import script from "./ThirdCompanyDetails.vue?vue&type=script&lang=js"
export * from "./ThirdCompanyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fb06cb",
  null
  
)

export default component.exports